
import request from './request'

export function getData() {

  return request.get('/getData')

}
